import React from "react";
import Context from "../../../../../context";

import {CustomModal} from "../../../../../components";

import "./index.scss";
import ServiceComponent from "./Components";

const UpdateService = ({role}: {role: "ADMIN" | "SUPER_AGENT_SCHOOL" | "COMPANY"}) => {
  // ** ===========================================================================================================
  // **                                            Values Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const {showModal, setShowModal} = React.useContext(Context.ServiceScreen);

  function UpdateServiceByRole() {
    switch (role) {
      case "ADMIN":
        return <ServiceComponent.Administrator />;
      case "SUPER_AGENT_SCHOOL":
        return <ServiceComponent.SuperAgent />;
      case "COMPANY":
        return <ServiceComponent.Company />;
      default:
        return null;
    }
  }

  return (
    <CustomModal onClose={() => setShowModal!("NONE")} open={showModal === "UPDATE_SERVICE"}>
      <UpdateServiceByRole />
    </CustomModal>
  );
};

export default UpdateService;
